<button
  type="button"
  mat-button
  matTooltip="Font Family"
  matTooltipShowDelay="300"
  [matMenuTriggerFor]="fontFamilyMenu"
  [matMenuTriggerRestoreFocus]="false"
  [ngClass]="{ active: activeFont$ | async }"
>
  <mat-icon>font_download</mat-icon>
</button>

<mat-menu #fontFamilyMenu="matMenu">
  <ng-template matMenuContent>
    <button
      type="button"
      mat-menu-item
      [ngClass]="{ active: isDefaultFontActive$ | async }"
      (click)="clearFont()"
    >
      <span>Default</span>
    </button>

    @for (font of fonts; track font.fontFamily) {
      <button
        type="button"
        mat-menu-item
        [ngClass]="{ active: (activeFont$ | async) === font.fontFamily }"
        (click)="selectFont(font)"
      >
        <span [style.font-family]="font.fontFamily">{{ font.name }}</span>
      </button>
    }
  </ng-template>
</mat-menu>
